import React from "react";
import { Box, Typography, Paper } from "@mui/material";

const UserMessage = ({ content }) => {
  return (
    <Box display="flex" justifyContent="flex-end" mb={2}>
      <Paper
        elevation={3}
        sx={{
          px: 2,
          py: 1.4,
          maxWidth: "75%",
          bgcolor: "#111", // Dark bubble
          color: "white",
          borderRadius: 3,
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.25)",
        }}
      >
        <Typography variant="body2" sx={{ fontSize: 14, lineHeight: 1.6 }}>
          {content}
        </Typography>
      </Paper>
    </Box>
  );
};

export default UserMessage;
